
import './App.css';
import Header from './component/Header/Header';
import Shop from './component/Shop/Shop';

function App() {
  return (
    <div >
      <Header />
      <Shop />
    </div>
  );
}

export default App;
